import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const ParameterText = styled.h3<{
  column?: number;
  $end?: boolean;
  showOperators?: boolean;
}>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  margin: 0;
  margin-bottom: 8px;
  margin-top: 20px;
  ${(props) => props.$end && 'align-self: end;'}
  ${(props) => !props.showOperators && props.$end && 'margin-top: 20px;'}
  grid-column-start: ${(props) => props.column ?? 'auto'};
`;

export const ParameterOperatorWrapper = styled.div<{
  isLastParameter?: boolean;
}>`
  padding: 3px 0;
  /*This is to mitigate the padding-top and keep div aligned*/
  margin-top: -3px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  display: flex;
  justify-content: center;
  flex-flow: column;
  ${(props) =>
    props.isLastParameter
      ? 'align-self: normal; flex-direction: row;'
      : 'align-self: flex-start; flex-direction: column;'}
  grid-column-start: 1;
  z-index: 1;
`;

export const ParameterOperator = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  margin: 0;
  border-radius: 3px;
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.outline.default};
  height: 40px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
